import { render, staticRenderFns } from "./ItemInfoAdvert.vue?vue&type=template&id=4cc46c07&scoped=true&"
import script from "./ItemInfoAdvert.vue?vue&type=script&lang=js&"
export * from "./ItemInfoAdvert.vue?vue&type=script&lang=js&"
import style0 from "./ItemInfoAdvert.vue?vue&type=style&index=0&id=4cc46c07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc46c07",
  null
  
)

export default component.exports